/* eslint-disable react/no-unused-state, comma-dangle, quote-props, no-undef */
/* react/jsx-closing-tag-location */

import React, { Component } from "react";
import { Fade } from "react-awesome-reveal";
import { collection, addDoc, onSnapshot } from "firebase/firestore";
import { signInAnonymously, onAuthStateChanged } from "firebase/auth";
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import { db, auth } from "../../firebase-config";
import "../../assets/css/styles.css";

export default class ContentSections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      images: [],
      type: "thumbnail",
      link: "",
      notes: "",
      cost: 50,
      loading: false,
      recaptchaToken: "",
      testimonials: [],
      testimonialName: "",
      testimonialText: "",
      testimonialRating: 5,
    };
  }

  componentDidMount() {
    const testimonialRef = collection(db, "testimonials");
    this.unsubscribe = onSnapshot(testimonialRef, (snapshot) => {
      const reviews = snapshot.docs
        .map((doc) => doc.data())
        .sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
      this.setState({ testimonials: reviews });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "images") {
      this.setState({ images: Array.from(files) });
    } else if (name === "type") {
      let cost = 50;
      if (value === "flyer") cost = 100;
      if (value === "long") cost = 150;
      this.setState({ type: value, cost });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleTestimonialSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "testimonials"), {
        name: this.state.testimonialName,
        review: this.state.testimonialText,
        rating: this.state.testimonialRating,
        createdAt: new Date(),
      });
      toast.success("Thank you for your feedback!");
      this.setState({
        testimonialName: "",
        testimonialText: "",
        testimonialRating: 5,
      });
    } catch (err) {
      console.error("Failed to submit testimonial:", err);
      toast.error("Submission failed. Please try again.");
    }
  };

  ensureAuth = async () => {
    if (auth.currentUser) return auth.currentUser;
    await signInAnonymously(auth);
    return new Promise((resolve, reject) => {
      const unsubscribe = onAuthStateChanged(
        auth,
        (user) => {
          if (user) {
            unsubscribe();
            resolve(user);
          }
        },
        (err) => {
          unsubscribe();
          reject(err);
        }
      );
    });
  };

  uploadImagesToFirebase = async () => {
    const { images } = this.state;
    if (!images.length) return [];

    // Ensure auth
    await this.ensureAuth();

    // Build Base64 payload
    const files = await Promise.all(
      Array.from(images).map(
        (f) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              const [, data] = reader.result.split(",");
              resolve({ name: f.name, type: f.type, data });
            };
            reader.readAsDataURL(f);
          })
      )
    );

    // Call Cloud Function
    const resp = await fetch(
      "https://us-central1-ttptechllc-5b637.cloudfunctions.net/uploadFiles",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ files }),
      }
    );

    const json = await resp.json();
    if (!resp.ok) throw new Error(json.error || "Upload failed");
    return json.uploaded;
  };

  handleSubmitReply = () => {
    const { name, type, cost, email, recaptchaToken } = this.state;

    if (!email || !recaptchaToken) {
      console.warn("❌ Email or reCAPTCHA missing");
      return;
    }

    emailjs
      .send(
        "service_q6dd0so", // ✅ Your service ID
        "template_opb36ju", // ✅ Your template ID
        {
          name,
          type,
          cost,
          to_email: email, // ✅ your field to send to the customer
          "g-recaptcha-response": recaptchaToken, // ✅ REQUIRED!
        },
        "usMEQvbkoTMfz3-5c" // ✅ Your new public key
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert("Success! Redirecting to payment..");
          // 8. Reset the Form
          this.setState({
            name: "",
            email: "",
            images: [],
            type: "thumbnail",
            link: "",
            notes: "",
            cost: 50,
          });
        },
        (error) => {
          console.log("FAILED...", error);
          // alert("There was an error sending the email. Please try again.");
        }
      );
    console.log(`❤️💩 ${this.state.email}`);
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    if (!this.recaptchaRef) {
      toast.error("reCAPTCHA not initialized.");
      return;
    }

    const token = await this.recaptchaRef.executeAsync();
    if (!token) {
      toast.error("reCAPTCHA verification failed.");
      return;
    }

    this.setState({ recaptchaToken: token, loading: true });

    const toastId = toast.info("Processing your request…", {
      autoClose: false,
    });

    try {
      // 1. Upload Images to Firebase
      const uploadedFiles = await this.uploadImagesToFirebase();
      if (!Array.isArray(uploadedFiles)) throw new Error("Image upload failed.");
      // 2. Save to Firestore
      await addDoc(collection(db, "customRequests"), {
        name: this.state.name,
        email: this.state.email,
        type: this.state.type,
        link: this.state.link || "N/A",
        notes: this.state.notes || "N/A",
        images: uploadedFiles,
        cost: this.state.cost,
        createdAt: new Date(),
      });

      // 3. Save to Google Form (Google Sheets)
      const googleFormURL =
        "https://docs.google.com/forms/d/e/1FAIpQLSfCyZlmOFnlzulJEjlE-fMPuLWFMbrGYEfsPSmqi9H5IQDNBg/formResponse";
      const googleFormData = new FormData();
      googleFormData.append("entry.756212597", this.state.name);
      googleFormData.append("entry.1827700625", this.state.email);
      googleFormData.append("entry.1140208245", this.state.type);
      googleFormData.append("entry.1999317729", this.state.link || "N/A");
      googleFormData.append("entry.899366288", this.state.notes || "N/A");
      googleFormData.append(
        "entry.1753142869",
        uploadedFiles.map((f) => f.url).join(", ")
      );
      googleFormData.append("entry.1610942308", this.state.cost);

      await fetch(googleFormURL, {
        method: "POST",
        mode: "no-cors",
        body: googleFormData,
      });
      // 4. Send Admin Notification to YOU via FormSubmit
      const formSubmitEndpoint =
        "https://formsubmit.co/ajax/ttptechllc@gmail.com";
      const adminFormData = new FormData();
      adminFormData.append("name", this.state.name);
      adminFormData.append("email", "info@ttptechllc.com"); // your own email here
      adminFormData.append("customer_email", this.state.email); // store customer's email safely
      adminFormData.append(
        "_subject",
        `New Custom Request: ${this.state.type}`
      );
      adminFormData.append("request_type", this.state.type);
      adminFormData.append("video_link", this.state.link || "N/A");
      adminFormData.append("notes", this.state.notes || "N/A");
      adminFormData.append("cost", this.state.cost);
      uploadedFiles.forEach((file, idx) => {
        adminFormData.append(`image_url_${idx + 1}`, file.url);
      });

      await fetch(formSubmitEndpoint, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: adminFormData,
      });

      // 6. Show Success Toast
      toast.update(toastId, {
        render: "Success! Redirecting to payment...",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });

      // 7. Redirect to Stripe
      const stripeLinks = {
        thumbnail: "https://buy.stripe.com/00gdSf2KQ1aJ98c6ow",
        flyer: "https://buy.stripe.com/fZe01p7163iR848aEL",
        long: "https://buy.stripe.com/5kA8xVclq7z7bgk14d",
      };

      setTimeout(() => {
        window.location.href = stripeLinks[this.state.type];
      }, 2500);

      this.handleSubmitReply();
    } catch (err) {
      console.error("Submission Error:", err);
      toast.update(toastId, {
        render:
          err.message || "An error occurred while submitting your request.",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading, name, type, cost, email, link, notes } = this.state;
    return (
      <div className="space-y-12">
        <Fade triggerOnce>
          {/* Instagram Embed Section */}
          <div className="text-center mt-12">
            <h2 className="text-3xl font-semibold text-white mb-6">
              Long Form ➡️ Short Form
            </h2>
            <iframe
              src="https://www.instagram.com/p/DIkWIFMSa6z/embed"
              width="400"
              height="500"
              frameBorder="0"
              scrolling="no"
              title="Instagram Reel"
            />
          </div>
          <section className="pt-10">
            <h2 className="text-xl text-white font-semibold mb-4 mt-30">
              Flyer Designs
            </h2>
          </section>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {[1, 2, 3].map((flyer) => (
              <div
                key={flyer}
                className={`rounded-2xl overflow-hidden shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300 ${
                  flyer === 2 ? "aspect-square" : "aspect-[3/4]"
                }`}
              >
                <img
                  src={`assets/images/flyer${flyer}.jpg`}
                  alt={`TTP TECH LLC Flyer ${flyer}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </Fade>

        <Fade triggerOnce>
          <h2 className="text-xl text-white font-semibold mb-4">
            YouTube Thumbnails
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((thumb) => (
              <div
                key={thumb}
                className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300 aspect-[16/9] group"
              >
                <img
                  src={`assets/images/y${thumb}.jpg`}
                  alt={`TTP TECH LLC Thumbnail ${thumb}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </Fade>

        <Fade triggerOnce>
          <section id="custom-request" className="pt-10">
            <h2 className="text-xl text-white font-semibold mb-4">
              Submit a Custom Request: {type}
            </h2>
            <form onSubmit={this.handleSubmit} className="space-y-4">
              <input type="hidden" name="_template" value="table" />
              <input
                type="hidden"
                name="_autoresponse"
                value="Thank you for your request! We've received your submission and will contact you soon."
              />
              <div>
                <label htmlFor="name" className="block text-white">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={name}
                  onChange={this.handleInputChange}
                  className="w-full text-black"
                  required
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-white">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={this.handleInputChange}
                  className="w-full text-black"
                  required
                />
              </div>

              <div>
                <label htmlFor="images" className="block text-white">
                  Upload Content Images
                </label>
                <input
                  type="file"
                  name="images"
                  id="images"
                  multiple
                  onChange={this.handleInputChange}
                  className="text-white"
                />
              </div>

              <div>
                <label htmlFor="type" className="block text-white">
                  Type
                </label>
                <select
                  name="type"
                  id="type"
                  value={type}
                  onChange={this.handleInputChange}
                  className="text-black"
                >
                  <option value="thumbnail">Thumbnail - $50</option>
                  <option value="flyer">Flyer - $100</option>
                  <option value="long">Long to Short Form Video - $150</option>
                </select>
              </div>

              <div>
                <label htmlFor="link" className="block text-white">
                  Video Link (YouTube, Google Drive, etc.)
                </label>
                <input
                  type="text"
                  name="link"
                  id="link"
                  value={link}
                  onChange={this.handleInputChange}
                  className="w-full text-black"
                />
              </div>

              <div>
                <label htmlFor="notes" className="block text-white">
                  Notes
                </label>
                <textarea
                  name="notes"
                  id="notes"
                  value={notes}
                  onChange={this.handleInputChange}
                  className="w-full h-24 text-black"
                />
              </div>

              <p className="text-white">Total: ${cost}</p>

              <div className="pt-4">
                <button
                  type="submit"
                  disabled={loading}
                  className={`bg-green-500 text-white px-6 py-3 rounded font-semibold flex items-center justify-center ${
                    loading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  {loading && (
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                  )}
                  {loading ? "Submitting..." : "Submit & Pay"}
                </button>
                <ReCAPTCHA
                  ref={(el) => (this.recaptchaRef = el)}
                  sitekey="6LfmOCUrAAAAABIU2RyGJ6t9oRjKtM6snEhA3ZCV" // 🔁 Replace this
                  size="invisible"
                  badge="bottomright" // optional, can be 'inline' or hidden with custom CSS
                  onChange={(token) => this.setState({ recaptchaToken: token })}
                  onErrored={() =>
                    toast.error("reCAPTCHA failed. Please try again.")
                  }
                />
                {/* <div className="text-gray-400 text-xs mt-4 text-center italic">
                  reCAPTCHA validation enforced for spam protection
                </div> */}
                <p className="text-xs text-gray-400 text-center mt-4">
                  This site is protected by reCAPTCHA and the Google{" "}
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noreferrer"
                    className="underline"
                  >
                    Privacy Policy
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://policies.google.com/terms"
                    target="_blank"
                    rel="noreferrer"
                    className="underline"
                  >
                    Terms of Service
                  </a>{" "}
                  apply.
                </p>

                <div className="text-xs text-gray-400 mt-6 space-y-1 leading-relaxed">
                  <p>
                    <strong>Project Flow:</strong>
                  </p>
                  <p>1. Submit the form with your project details</p>
                  <p>2. Submit your payment on the next screen</p>
                  <p>
                    3. Receive a confirmation email from{" "}
                    <span className="font-semibold text-green-400">
                      info@ttptechllc.com
                    </span>
                  </p>
                  <p>4. Project delivered within 2–4 business days</p>
                  <p>
                    5. Up to 3 revisions available during the review process
                  </p>
                </div>
              </div>
            </form>
          </section>
        </Fade>
        {/* <section className="pt-16">
        <h2 className="text-xl text-white font-semibold mb-6 text-center">
          ⭐ What Our Clients Are Saying
        </h2>
        <div className="overflow-x-auto w-full">
          <div className="flex space-x-6 px-4 pb-4 animate-scroll min-w-full">
            {this.state.testimonials.map((t, index) => (
              <div
                key={index}
                className="min-w-[300px] bg-white rounded-xl shadow-md p-6 text-black flex-shrink-0"
              >
                <p className="font-semibold text-lg mb-1">{t.name}</p>
                <div className="text-yellow-500 mb-2">
                  {"\u2605".repeat(t.rating)}
                  {"\u2606".repeat(5 - t.rating)}
                </div>
                <p className="text-sm text-gray-700">{t.review}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 max-w-xl mx-auto">
          <h3 className="text-white text-center text-lg font-semibold mb-4">
            Leave a Testimonial
          </h3>
          <form
            onSubmit={this.handleTestimonialSubmit}
            className="bg-white p-6 rounded-xl shadow-lg text-black space-y-4"
          >
            <input
              type="text"
              placeholder="Your name"
              value={this.state.testimonialName}
              onChange={(e) =>
                this.setState({ testimonialName: e.target.value })
              }
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
            <textarea
              placeholder="Your review"
              value={this.state.testimonialText}
              onChange={(e) =>
                this.setState({ testimonialText: e.target.value })
              }
              className="w-full p-2 border border-gray-300 rounded"
              rows={4}
              required
            />
            <select
              value={this.state.testimonialRating}
              onChange={(e) =>
                this.setState({ testimonialRating: parseInt(e.target.value, 10) })
              }
              className="w-full p-2 border border-gray-300 rounded"
            >
              {[5, 4, 3, 2, 1].map((r) => (
                <option key={r} value={r}>
                  {r} Star{r !== 1 && "s"}
                </option>
              ))}
            </select>
            <button
              type="submit"
              className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded font-semibold"
            >
              Submit Review
            </button>
          </form>
        </div>
        </section> */}
      </div>
    );
  }
}
